import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
// Impor ikon untuk memperjelas setiap langkah
import { FaSearch, FaHandshake, FaGavel, FaMoneyBillWave } from 'react-icons/fa';

const SellingPage = () => {
    return (
        <div className="py-5" style={{ backgroundColor: '#f0efe9' }}>
            <Container>
                <div className="text-center mb-5">
                    <h1 className="display-4" style={{ fontFamily: 'Cinzel, serif' }}>Jual atau Titipkan Barang Anda</h1>
                    <p className="lead" style={{ fontFamily: 'Poppins, sans-serif' }}>
                        Miliki barang numismatik berharga? Mari kami bantu untuk mendapatkan nilai terbaik melalui lelang kami.
                    </p>
                </div>

                <h2 className="text-center mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>Proses Penjualan yang Mudah</h2>

                <Row className="g-4">
                    {/* Langkah 1: Evaluasi */}
                    <Col md={6} lg={3}>
                        <Card className="text-center h-100 shadow-sm">
                            <Card.Body>
                                <FaSearch size={40} className="mb-3" style={{ color: '#c5a65B' }} />
                                <Card.Title>1. Evaluasi</Card.Title>
                                <Card.Text>
                                    Kirimkan foto dan deskripsi barang Anda kepada tim ahli kami untuk mendapatkan evaluasi awal gratis tanpa komitmen.
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                    {/* Langkah 2: Konsinyasi */}
                    <Col md={6} lg={3}>
                        <Card className="text-center h-100 shadow-sm">
                            <Card.Body>
                                <FaHandshake size={40} className="mb-3" style={{ color: '#c5a65B' }} />
                                <Card.Title>2. Perjanjian</Card.Title>
                                <Card.Text>
                                    Jika Anda setuju dengan harga estimasi kami, kita akan membuat perjanjian konsinyasi yang jelas dan transparan.
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                    {/* Langkah 3: Lelang */}
                    <Col md={6} lg={3}>
                        <Card className="text-center h-100 shadow-sm">
                            <Card.Body>
                                <FaGavel size={40} className="mb-3" style={{ color: '#c5a65B' }} />
                                <Card.Title>3. Lelang</Card.Title>
                                <Card.Text>
                                    Barang Anda akan kami promosikan dan masukkan ke dalam jadwal lelang kami yang akan diikuti oleh para kolektor serius.
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                    {/* Langkah 4: Pembayaran */}
                    <Col md={6} lg={3}>
                        <Card className="text-center h-100 shadow-sm">
                            <Card.Body>
                                <FaMoneyBillWave size={40} className="mb-3" style={{ color: '#c5a65B' }} />
                                <Card.Title>4. Pembayaran</Card.Title>
                                <Card.Text>
                                    Setelah barang berhasil terjual, Anda akan menerima pembayaran penuh dikurangi dengan komisi yang telah disepakati.
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                {/* Bagian Call to Action */}
                <div className="text-center mt-5 p-4 shadow-sm" style={{backgroundColor: '#fff', borderRadius: '8px'}}>
                    <h3 style={{ fontFamily: 'Poppins, sans-serif' }}>Siap Memulai?</h3>
                    <p>Kirimkan informasi barang Anda sekarang untuk memulai proses evaluasi.</p>
                    <Button as={Link} to="/contact" variant="dark" size="lg">Hubungi Kami Sekarang</Button>
                </div>
            </Container>
        </div>
    );
}

export default SellingPage;
